<div class="flex justify-center items-start max-w-[1300px] w-[90vw] mx-auto">
  @for (steper of listSteps; track $index; let i = $index) {
    <div
      class="w-[90px] desktop:w-auto flex justify-center items-center gap-2 rounded-lg transition-all duration-500 ease-in-out hover:bg-neutral-200"
      [ngClass]="{
        'hover:cursor-pointer hover:bg-neutral-200': !steper.disabled,
        'hover:cursor-not-allowed': steper.disabled,
        'flex-col p-2': !isMobile,
        'p-6': isMobile,
      }"
      (click)="!steper.disabled ? goToStep(i) : null"
      (keypress)="!steper.disabled ? goToStep(i) : null"
      [attr.tabindex]="!steper.disabled ? 0 : -1"
      [attr.aria-disabled]="steper.disabled"
      [attr.aria-label]="steper.title"
      [attr.aria-selected]="steper.select"
      [attr.aria-setsize]="listSteps.length"
      [attr.aria-posinset]="i + 1"
      [attr.aria-labelledby]="steper.title">
      <div
        class="flex h-6 w-6 bg-secondary-600 rounded-full justify-center items-center"
        [ngClass]="{
          'bg-primary-800': !steper.disabled && steper.filled,
          'bg-secondary-600': !steper.disabled && steper.select,
          'bg-primary-500': steper.disabled,
        }">
        <p class="text-purple-50 text-2xs font-medium">{{ $index + 1 }}</p>
      </div>
      <div class="min-w-[80px]">
        <p
          class="text-xs font-medium"
          [ngClass]="{
            'text-primary-900': !steper.disabled && steper.filled,
            'text-secondary-600': !steper.disabled && steper.select,
            'text-primary-500': steper.disabled,
            'text-nowrap': isMobile,
            'text-balance text-center': !isMobile,
          }">
          {{ steper.title }}
        </p>
      </div>
    </div>
    @if (i < listSteps.length - 1) {
      <div
        class="h-[1px] w-full my-auto"
        [ngClass]="{
          'bg-primary-700': !listSteps[i + 1].disabled,
          'bg-primary-400': listSteps[i + 1].disabled,
        }"></div>
    }
  }
</div>
